import React from "react";

interface CriteriaItem {
  title: string;
  description: string;
}

export const WhiteStar: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    className="w-4 h-4"
  >
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 
      9.24l-7.19-.61L12 2 9.19 8.63 2 
      9.24l5.46 4.73L5.82 21z" />
  </svg>
);

const RatingSection: React.FC = () => {
  const criteriaList: CriteriaItem[] = [
    {
      title: "Price & Value",
      description: "Fair pricing and good quality",
    },
    {
      title: "Flower & Gifts Variety",
      description: "Diverse arrangements",
    },
    {
      title: "Delivery",
      description: "Same-day availability in select areas",
    },
    {
      title: "Customer Feedback",
      description: "Positive reviews, reliability",
    },
    {
      title: "Website Usability",
      description: "Easy to browse & checkout",
    },
  ];

  return (
    <section className="font-inter">
      <div className="max-w-6xl mx-auto py-6">
        {/* Heading / Description */}
        <div className="mb-6 w-full md:w-4/5">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 font-figtree">
            How do we rate?
          </h2>
          <p className="text-gray-600 leading-snug mb-4 font-inter">
            We’ve tested over 140+ flower delivery companies across the US to
            bring you the very best. We continuously order and evaluate their
            services, rating them to ensure you get top-quality options.
          </p>
          <p className="text-gray-600 leading-snug m-0 font-bold font-inter">
            We evaluate each service on a scale of 1 to 10 across five key
            criteria and calculate the average score.
          </p>
        </div>

        {/* Main Container: mobile = stacked, desktop = 2 columns */}
        <div
          className="
            bg-white 
            rounded-2xl 
            shadow-xl 
            px-4 
            py-4 
            flex 
            flex-col 
            items-start  
            md:flex-row 
            md:items-center 
          "
        >
          {/* LEFT COLUMN (Circle) */}
          <div
            className="
              w-full 
              mb-4 
              md:mb-0 
              md:w-1/3 
              flex 
              justify-center   /* on mobile: center horizontally, too */
              md:justify-center /* on desktop: center horizontally */
            "
          >
            <div className="relative w-40 h-40">
              <svg
                className="w-full h-full"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
              >
                 <defs>
                    <filter
                        id="dashShadow"
                        x="-50%"   /* expand the area on all sides */
                        y="-50%"
                        width="200%"
                        height="200%"
                        filterUnits="userSpaceOnUse" 
                    >
                        <feDropShadow
                        dx="0"
                        dy="1"
                        stdDeviation="3"
                        floodColor="#000"
                        floodOpacity="0.3"
                        />
                    </filter>
                  </defs>
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  fill="none"
                  stroke="#F59E0B"
                  strokeWidth="6"
                  strokeDasharray="46 10"
                  strokeLinecap="round" 
                  filter="url(#dashShadow)"
                />
              </svg>
              {/* Text inside the circle */}
              <span className="absolute bottom-[45%] left-1/2 transform -translate-x-1/2 text-3xl font-medium text-gray-800 leading-none font-dmsans">
                100%
              </span>
              <span className="absolute bottom-[35%] left-1/2 transform -translate-x-1/2 text-sm text-gray-600 leading-none font-dmsans">
                Rate 0-10
              </span>
            </div>
          </div>

          {/* RIGHT COLUMN (Criteria List) */}
          <div className="w-full md:w-2/3 md:pl-8  md:pt-4 font-dmsans">
            {criteriaList.map((item, i) => (
              <div
                key={i}
                className="flex items-start justify-between mb-4"
              >
                {/* Star + Title/Description */}
                <div className="flex items-start">
                  <div className="inline-flex items-center justify-center w-6 h-6 bg-amber-500 text-white rounded-sm mr-3 mt-1">
                    <WhiteStar />
                  </div>
                  <div>
                    <h4 className="font-semibold text-base leading-tight m-0">
                      {item.title}
                    </h4>
                    <p className="text-sm text-gray-600 leading-tight m-0">
                      {item.description}
                    </p>
                  </div>
                </div>

                {/* "20%" on the far right */}
                <div className="text-sm font-bold text-gray-800 md:px-8 font-inter">
                  20%
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RatingSection;
